import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BallotRoutingModule } from './ballot-routing.module';
import { BallotsComponent } from './ballots.component';
import { IecDetailsComponent } from './iec/iec-details/iec-details.component';
import { IecComponent } from './iec/iec.component';
import { GenerateReportButtonComponent } from './shared/components/generate-report-button/generate-report-button.component';
import { IecReportComponent } from './iec/iec-report/iec-report.component';
import { SdDetailsComponent } from './sd/sd-details/sd-details.component';
import { ControlsModule } from '../controls/controls.module';
import { SrsDetailsComponent } from './srs/srs-details/srs-details.component';
import { ButtonVoteNowComponent } from './shared/components/button-vote-now/button-vote-now.component';
import { UserHasVotedComponent } from './user-has-voted/user-has-voted.component';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { MatDividerModule } from '@angular/material/divider';
import { BallotDashboardComponent } from './ballot-dashboard/ballot-dashboard.component';

import { SelectMultipleBallotTypeComponent } from './shared/components/select-multiple-ballot-type/select-multiple-ballot-type.component';
import { SrsCreateComponent } from './srs/srs-create/srs-create.component';
import { CibCreateComponent } from './cib/cib-create/cib-create.component';
import { IecCreateComponent } from './iec/iec-create/iec-create.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { BallotCreateDatesComponent } from './ballot-create-dates/ballot-create-dates.component';
import { SelectMultipleBallotStatusComponent } from './shared/components/select-multiple-ballot-status/select-multiple-ballot-status.component';
import { SrsSummaryComponent } from './srs/srs-details/srs-summary/srs-summary.component';
import { SrsVotesComponent } from './srs/srs-details/srs-votes/srs-votes.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { YellowDashComponent } from './shared/components/yellow-dash/yellow-dash.component';
import { CommitteesModule } from '../committees/committees.module';
import { SrsBallotGuidanceComponent } from './srs/srs-details/srs-ballot-guidance/srs-ballot-guidance.component';
import { SrsPlaceVoteComponent } from './srs/srs-place-vote/srs-place-vote.component';
import { SrsEligibleVotersComponent } from './srs/srs-details/srs-eligible-voters/srs-eligible-voters.component';
import { SdSummaryComponent } from './sd/sd-details/sd-summary/sd-summary.component';
import { SdEligibleVotersComponent } from './sd/sd-details/sd-eligible-voters/sd-eligible-voters.component';
import { SdPlaceVoteComponent } from './sd/sd-place-vote/sd-place-vote.component';
import { SrsConsensusCriteriaComponent } from './srs/srs-details/srs-consensus-criteria/srs-consensus-criteria.component';
import { IecSummaryComponent } from './iec/iec-details/iec-summary/iec-summary.component';
import { IecEligibleVotersComponent } from './iec/iec-details/iec-eligible-voters/iec-eligible-voters.component';
import { CiDetailsComponent } from './cib/cib-details/ci-details.component';
import { CiSummaryComponent } from './cib/cib-details/ci-summary/ci-summary.component';
import { CiEligibleVotersComponent } from './cib/cib-details/ci-eligible-voters/ci-eligible-voters.component';
import { IecPlaceVoteComponent } from './iec/iec-place-vote/iec-place-vote.component';
import { CibPlaceVoteComponent } from './cib/cib-place-vote/cib-place-vote.component';
import { SdConsensusCriteriaComponent } from './sd/sd-details/sd-consensus-criteria/sd-consensus-criteria.component';
import { IecConsensusCriteriaComponent } from './iec/iec-details/iec-consensus-criteria/iec-consensus-criteria.component';
import { CiConsensusCriteriaComponent } from './cib/cib-details/ci-consensus-criteria/ci-consensus-criteria.component';
import { SrsVoteColumnComponent } from './srs/srs-details/srs-votes/srs-vote-column/srs-vote-column.component';
import { SrsHistoryColumnComponent } from './srs/srs-details/srs-votes/srs-history-column/srs-history-column.component';
import { SrsProxyVoteComponent } from './srs/srs-proxy-vote/srs-proxy-vote.component';
import { SdVoteColumnComponent } from './sd/sd-details/sd-votes/sd-vote-column/sd-vote-column.component';
import { SdHistoryColumnComponent } from './sd/sd-details/sd-votes/sd-history-column/sd-history-column.component';
import { SdVotesComponent } from './sd/sd-details/sd-votes/sd-votes.component';
import { ViewVotesPopoverComponent } from './shared/components/view-votes-popover/view-votes-popover.component';
import { VotesDocumentsPopoverComponent } from './shared/components/votes-documents-popover/votes-documents-popover.component';
import { SrsFinaliseBallotModalComponent } from './srs/srs-details/srs-modals/srs-finalise-ballot-modal/srs-finalise-ballot-modal.component';
import { IecHistoryColumnComponent } from './iec/iec-details/iec-votes/iec-history-column/iec-history-column.component';
import { IecVoteColumnComponent } from './iec/iec-details/iec-votes/iec-vote-column/iec-vote-column.component';
import { IecVotesComponent } from './iec/iec-details/iec-votes/iec-votes.component';
import { CibHistoryColumnComponent } from './cib/cib-details/cib-votes/cib-history-column/cib-history-column.component';
import { CibVoteColumnComponent } from './cib/cib-details/cib-votes/cib-vote-column/cib-vote-column.component';
import { CibVotesComponent } from './cib/cib-details/cib-votes/cib-votes.component';
import { SrsReportComponent } from './srs/srs-report/srs-report.component';
import { VoteOptionCardComponent } from './shared/components/proxy-vote/vote-option-card/vote-option-card.component';
import { SdProxyVoteComponent } from './sd/sd-details/sd-proxy-vote/sd-proxy-vote.component';
import { SelectProxyVoteOptionComponent } from './shared/components/proxy-vote/select-proxy-vote-option/select-proxy-vote-option.component';
import { SdCertificateOfAppreciationComponent } from './sd/sd-details/sd-certificate-of-appreciation/sd-certificate-of-appreciation.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { SdFinaliseBallotModalComponent } from './sd/sd-details/sd-finalise-ballot-modal/sd-finalise-ballot-modal.component';
import { CibReportComponent } from './cib/cib-report/cib-report.component';
import { IecFinaliseBallotModalComponent } from './iec/iec-details/iec-finalise-ballot-modal/iec-finalise-ballot-modal.component';
import { CibFinaliseBallotModalComponent } from './cib/cib-details/cib-finalise-ballot-modal/cib-finalise-ballot-modal.component';
import { HeaderBallotTypeComponent } from './shared/components/header-ballot-type/header-ballot-type.component';
import { VoteLegendComponent } from './shared/components/vote-legend/vote-legend.component';
import { BallotInternalHistoryComponent } from './shared/components/ballot-internal-history/ballot-internal-history.component';
import { BallotHistoryComponent } from './shared/components/ballot-history/ballot-history.component';
import { SrsReviewModalComponent } from './srs/srs-details/srs-modals/srs-review-modal/srs-review-modal.component';
import { ViewVoteDocumentsPopoverComponent } from './shared/components/view-vote-documents-popover/view-vote-documents-popover.component';
import { BallotReviewStageBadgeComponent } from './shared/components/ballot-review-stage-badge/ballot-review-stage-badge.component';
import { SelectMultipleBallotReviewStageComponent } from './shared/components/select-multiple-ballot-review-stage/select-multiple-ballot-review-stage.component';
import { SrsBallotReviewActionsComponent } from './srs/srs-details/srs-ballot-review-actions/srs-ballot-review-actions.component';
import { SdNonEligibleCommentModalComponent } from './sd/sd-details/sd-non-eligible-comment-modal/sd-non-eligible-comment-modal.component';
import { ViewVotesPopoverIneligibleComponent } from './shared/components/view-votes-popover-ineligible/view-votes-popover-ineligible.component';
import { ModalComponent } from '../../shared/modal/modal.component';

@NgModule({
  declarations: [
    BallotsComponent,
    IecComponent,
    IecDetailsComponent,
    GenerateReportButtonComponent,
    IecReportComponent,
    SdDetailsComponent,
    SrsDetailsComponent,
    ButtonVoteNowComponent,
    UserHasVotedComponent,
    SrsCreateComponent,
    BallotDashboardComponent,
    CibCreateComponent,
    IecCreateComponent,
    SelectMultipleBallotTypeComponent,
    SelectMultipleBallotStatusComponent,
    BallotCreateDatesComponent,
    SrsSummaryComponent,
    SrsVotesComponent,
    YellowDashComponent,
    SrsBallotGuidanceComponent,
    ModalComponent,
    SrsPlaceVoteComponent,
    SrsEligibleVotersComponent,
    SdSummaryComponent,
    SdEligibleVotersComponent,
    SdPlaceVoteComponent,
    SrsConsensusCriteriaComponent,
    IecSummaryComponent,
    IecEligibleVotersComponent,
    CiDetailsComponent,
    CiSummaryComponent,
    CiEligibleVotersComponent,
    IecPlaceVoteComponent,
    CibPlaceVoteComponent,
    SdConsensusCriteriaComponent,
    IecConsensusCriteriaComponent,
    CiConsensusCriteriaComponent,
    SrsVoteColumnComponent,
    SrsHistoryColumnComponent,
    SrsProxyVoteComponent,
    SrsFinaliseBallotModalComponent,
    SdVoteColumnComponent,
    SdHistoryColumnComponent,
    SdVotesComponent,
    ViewVotesPopoverComponent,
    VotesDocumentsPopoverComponent,
    IecHistoryColumnComponent,
    IecVoteColumnComponent,
    IecVotesComponent,
    CibHistoryColumnComponent,
    CibVoteColumnComponent,
    CibVotesComponent,
    SrsReportComponent,
    VoteOptionCardComponent,
    SdProxyVoteComponent,
    SelectProxyVoteOptionComponent,
    SdCertificateOfAppreciationComponent,
    SdFinaliseBallotModalComponent,
    CibReportComponent,
    IecFinaliseBallotModalComponent,
    CibFinaliseBallotModalComponent,
    HeaderBallotTypeComponent,
    VoteLegendComponent,
    BallotInternalHistoryComponent,
    BallotHistoryComponent,
    SrsReviewModalComponent,
    ViewVoteDocumentsPopoverComponent,
    BallotReviewStageBadgeComponent,
    SelectMultipleBallotReviewStageComponent,
    SrsBallotReviewActionsComponent,
    SdNonEligibleCommentModalComponent,
    ViewVotesPopoverIneligibleComponent
  ],
  imports: [
    CommonModule,
    BallotRoutingModule,
    ControlsModule,
    NgbPopoverModule,
    MatDividerModule,
    FormsModule,
    ReactiveFormsModule,
    MatDividerModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    FontAwesomeModule,
    CommitteesModule,
    MatProgressSpinner
  ]
})
export class BallotsModule { }
